export default function($stateProvider) {
    $stateProvider
        .state('ordinacija', {
            url: '/ordinacija',
            template: '<ordinacija-list></ordinacija-list>',
            data: {
                pageTitle: 'Ordinacije dentalne medicine',
                pageDesc: 'Registar ordinacija dentalne medicine',
                icon: '<i class="fa fa-building fa-3x"></i>'
            }
        })
        .state('ordinacija.details', {
            url: '/details/:id',
            views: {
                '@' : {
                    // template: '<ordinacija-details></ordinacija-details>',
                    component: 'ordinacijaDetails'
                }
            },
            resolve: {
                item: ['$transition$', 'DS', function($transition$, DS) {
                    const params = $transition$.params();
                    return DS.find('Ordinacija', params.id);
                }]
            },
             data: {
                pageTitle: 'Detalji ordinacije',
            }
        })

        .state('ordinacija.create', {
            url: '/create',
            views: {
                '@': {
                    component: 'ordinacijaCreate'
                }
            },
            resolve: {
                item: () => { return {};}
            }

        })
        .state('ordinacija.details.edit', {
            url:'/edit',
            views: {
                '@': {
                    component: 'ordinacijaEdit'
                }
            },
            resolve: {
                item: ['DS', '$transition$', (DS, $transition$) => {
                    const params = $transition$.params();
                    return DS.find('Ordinacija', params.id);
                }]
            }
        });

}



// WEBPACK FOOTER //
// ./app/components/ordinacija/states.js